import Rails from '@rails/ujs';
window.Rails = Rails;

if (!window._rails_loaded) {
  Rails.start();
}
